// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__rmDWt","rootSuccess":"CompleteLink_rootSuccess__1vg4b","rootFailure":"CompleteLink_rootFailure__3Cp8b","isDisabled":"CompleteLink_isDisabled__nvP4e"};